import { SHOW_COCO_SEARCH_MARKER,  HIDE_COCO_SEARCH_MARKER} from "./cocoSearchMarkerReducer"

export const showCocoSearchMarker = (position) => ({
    type: SHOW_COCO_SEARCH_MARKER,
    payload: position
})

export const hideCocoSearchMarker = () => ({
    type: HIDE_COCO_SEARCH_MARKER,
})